import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import { elementDataPropertyCard } from "../styles";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import BathtubIcon from "@mui/icons-material/Bathtub";
import { Link } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import { AutoGraph, KingBed } from "@mui/icons-material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DonutLargeIcon from "@mui/icons-material/DonutLarge";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import NoMaxWidthTooltip from "./NoMaxWidthTooltip";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

function CardElement({
  data,
  columns = 3,
  sizes = { xs: 3, lg: 1, sm: 1.5 },
  type = "property",
}) {
  return (
    <Stack pt={3}>
      <Grid container columns={columns} spacing={4}>
        {data.length === 0 ? (
          <Typography
            width="100%"
            component="span"
            textAlign="center"
            sx={{ marginInline: "auto", pt: 8 }}
            variant="subtitle1"
            color="GrayText"
          >
            {type === "property"
              ? "No se encontraron inmuebles"
              : "No se encontraron proyectos"}
          </Typography>
        ) : (
          ""
        )}
        {(data || []).map((element, index) => {
          return (
            <Grid item key={index} xs={sizes.xs} lg={sizes.lg} sm={sizes.sm}>
              <Box>
                <Box
                  sx={{ width: "100%", height: { xs: 230, xl: 230 }, mb: 0.5 }}
                >
                  <img
                    src={
                      element?.photo_profile[0]?.url ||
                      "https://imageio.forbes.com/specials-images/imageserve/633a774a842d06ecd68286ff/The-5-Biggest-Business-Trends-For-2023/960x0.jpg"
                    }
                    width="100%"
                    height="100%"
                    style={{ borderRadius: 5, objectFit: "cover" }}
                  />
                </Box>
                <Stack mb={1}>
                  <Typography
                    component="h3"
                    variant="subtitle1"
                    sx={{
                      fontFamily: "Inter",
                      fontWeight: 700,
                      overflowX: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {element.name}
                  </Typography>
                  <Stack flexDirection={"row"} gap={1.5}>
                    {element.purpose_use && (
                      <NoMaxWidthTooltip
                        title="Propósito de uso"
                        arrow
                      >
                        <Typography
                          component="span"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.4,
                            fontWeight: "normal",
                            backgroundColor: "lightgray",
                            width: "fit-content",
                            borderRadius: 5,
                            px: 1,
                            fontSize: "small",
                            mb: 1,
                            mt: 1,
                            color: "#6e6e6e",
                          }}
                        >
                          <MonetizationOnIcon fontSize="xxs" />
                          {element.purpose_use}
                        </Typography>
                      </NoMaxWidthTooltip>
                    )}
                    {element.location && (
                      <NoMaxWidthTooltip
                        title="Ubicación"
                        arrow
                      >
                        <Typography
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.4,
                            fontWeight: "normal",
                            backgroundColor: "lightgray",
                            width: "fit-content",
                            borderRadius: 5,
                            px: 1,
                            fontSize: "small",
                            mb: 1,
                            mt: 1,
                            color: "#6e6e6e",
                          }}
                        >
                          <LocationOnIcon fontSize="xxs" />
                          {element.location}
                        </Typography>
                      </NoMaxWidthTooltip>

                    )}

                    {element.type ? (
                      <NoMaxWidthTooltip
                        title="Tipo"
                        arrow
                      >
                        <Typography
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.4,
                            fontWeight: "normal",
                            backgroundColor: "lightgray",
                            width: "fit-content",
                            borderRadius: 5,
                            px: 1,
                            fontSize: "small",
                            mb: 1,
                            mt: 1,
                            color: "#6e6e6e",
                          }}
                        >
                          <HomeWorkIcon fontSize="xxs" />
                          {element.type}
                        </Typography>
                      </NoMaxWidthTooltip>
                    ) : null}
                  </Stack>
                </Stack>
                <Stack mb={1} sx={{ overflowX: "hidden" }}>
                  <Typography
                    width="100%"
                    fontWeight="400"
                    variant="subtitle2"
                    sx={{
                      fontFamily: "Inter",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      WebkitLineClamp: 1, // Ajusta el número de líneas visibles aquí
                    }}
                  >
                    {element.information || element.description}
                  </Typography>
                </Stack>
                <Stack
                  component="ul"
                  flexDirection="row"
                  justifyContent="space-between"
                  pl={0}
                  sx={{ mb: 1.5, marginTop: 0 }}
                >
                  <NoMaxWidthTooltip
                    title="Precio"
                    arrow
                  >
                    <Stack component="li" sx={{ ...elementDataPropertyCard }}>
                      <LocalAtmIcon />
                      {element.price
                        ? parseInt(element.price).toLocaleString("es-CO")
                        : parseInt(element.data.objective).toLocaleString(
                          "es-CO"
                        )}
                      €
                    </Stack>
                  </NoMaxWidthTooltip>
                  <NoMaxWidthTooltip
                    title="Número de habitaciones"
                    arrow
                  >
                    <Stack component="li" sx={{ ...elementDataPropertyCard }}>
                      {element.bedrooms ? <KingBed /> : <PersonIcon />}
                      {element.bedrooms || element.data.cant_investors}
                    </Stack>
                  </NoMaxWidthTooltip>
                  <NoMaxWidthTooltip
                    title="Metros cuadrados"
                    arrow
                  >
                    <Stack component="li" sx={{ ...elementDataPropertyCard }}>
                      {element.m2 ? <AspectRatioIcon /> : <AccessTimeIcon />}
                      {element.m2 || element.data.remaindingDays}
                    </Stack>
                  </NoMaxWidthTooltip>
                  <NoMaxWidthTooltip
                    title="Cantidad de baños"
                    arrow
                  >
                    <Stack component="li" sx={{ ...elementDataPropertyCard }}>
                      {element.bathrooms ? <BathtubIcon /> : <DonutLargeIcon />}
                      {element.bathrooms || element.data.completed + "%"}
                    </Stack>
                  </NoMaxWidthTooltip>
                </Stack>
                <Button
                  size="small"
                  variant="contained"
                  sx={{
                    px: "0.5rem",
                    width: "fit-content",
                    color: "white",
                    backgroundColor: "primary.main",
                    borderRadius: 2,
                    "&:hover": {
                      backgroundColor: "primary.300",
                    },
                  }}
                  startIcon={<FindInPageIcon fontSize="small" />}
                  LinkComponent={Link}
                  to={`/details/property/${element.id}`}
                >
                  Detalles
                </Button>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Stack>
  );
}

export default CardElement;
